export default {
  hunt: null,
  hunts: null,

  state: ''
}
